import React, { useState } from 'react'
import "./NewsAndAnnouncementDetail.scoped.scss"
import { ArrowUpRight } from "lucide-react"

const ItemsList = ({ isMobile, setOnOpenDetail, activeTab, setActiveTab,
  announcement, news, setListId, listId, imageDefault }) => {

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
    setListId(tab === "news" ? announcement[0].Id : news[0].Id);
  }

  const handleSelect = (id) => {
    setListId(id);
    if (isMobile) {
      setOnOpenDetail(id);
    }
  }

  return (
    <div className="container">
      <div className="tab-container">
        <button
          className={`tab ${activeTab === "banner" ? "active" : ""}`}
          onClick={() => handleChangeTab("banner")}
        >
          News
        </button>
        <button
          className={`tab ${activeTab === "news" ? "active" : ""}`}
          onClick={() => handleChangeTab("news")}
        >
          Announcement
        </button>
      </div>

      <div className="news-list">
        {(activeTab === "news" ? announcement : news)?.map((item, index) => (
          <div key={item.Id} className="news-item" onClick={() => handleSelect(item.Id)}>
            <div className={`news-item-content ${item.Id === listId && !isMobile ? "active" : ""}`}>
              <div className="number-badge">{String(index + 1).padStart(2, "0")}</div>
              <img
                className={`${activeTab === "news" ? "avatar-announce" : "avatar-news"}`}
                src={
                  activeTab === 'news'
                    ? `/img/vendors/icon/${item.IconUrl || '1'}.png`
                    : imageDefault.includes(item.IconUrl) ?
                      `/img/vendors/news/${item.IconUrl}.jpg`
                      : `api/Announcement/Image/${item.IconUrl}`
                }
                alt='avatar'
              />
              <div className="content">
                <h3 className="title">{item.Topic}</h3>
                <p className="description">{item.SubTopic}</p>
              </div>
              {isMobile && (
                <div className="news-item-content-arrow">
                  <ArrowUpRight className="arrow-icon" />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ItemsList